import React, { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { Typography } from '@mui/material'
import { routes } from 'config'
import { constants } from 'utils'
import {
  Module,
  ModuleHeader,
  ModuleBody,
  CustomAlert,
  CustomButton,
  ButtonContainer,
} from 'components'

interface IProps {
  transaction: any
  serviceError: string
}

const EmailSentConfirmation: FC<IProps> = ({ transaction, serviceError }) => {
  const navigate = useNavigate()

  return (
    <Module>
      <ModuleHeader title="You're all set!">
        <CustomAlert severity="success" title="Success!">
          If you are a Bright MLS subscriber, an email with your Login Name has
          been sent to <strong>{transaction.data.email}</strong>.
        </CustomAlert>
        <CustomAlert severity="error">{serviceError}</CustomAlert>
      </ModuleHeader>

      <ModuleBody>
        <Typography variant="body1">
          The email was sent from{' '}
          <strong className="no-wrap">{constants.NO_REPLY_EMAIL_AWS}</strong>.
          If that email does not arrive soon, please check your spam folder.
        </Typography>

        <ButtonContainer
          primary={
            <CustomButton onClick={() => navigate(routes.login)}>
              Return to Login
            </CustomButton>
          }
          secondary={<div />}
        />
      </ModuleBody>
    </Module>
  )
}

export default EmailSentConfirmation
